import React from 'react';
import { useDispatch } from 'react-redux';
import { Box, IconButton } from '@mui/material';
import { Edit as EditIcon, Close as CloseIcon } from '@mui/icons-material';
import PropTypes from 'prop-types';
import ProfileEdit from './ProfileEdit';
import ProfilePicture from './ProfilePicture';
import ProfileShow from './ProfileShow';
import { useGetProfileQuery } from '../../features/api/rest/apiProfileSlice';
import { mapProfileData } from '../../utils/profileUtils';
import CookiePreferenceButton from '../Layout/Cookies/CookiePreferenceButton';
import { openCookiePreferences as openCookiePreferencesAction } from '../../features/layoutSlice';

function HandleButton({ mode, setMode }) {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
      <IconButton variant="solid" size="small" color="neutral" onClick={() => setMode()} data-testid="ProfileEditButton">
        {mode === 'edit' ? <CloseIcon /> : <EditIcon />}
      </IconButton>
    </Box>
  );
}

HandleButton.propTypes = {
  setMode: PropTypes.func.isRequired,
  mode: PropTypes.string.isRequired,
};

function Profile() {
  const [mode, setMode] = React.useReducer((state) => (state === 'edit' ? 'view' : 'edit'), 'view');
  const { profile, profilePicture } = useGetProfileQuery(undefined, {
    selectFromResult: ({ currentData }) => ({
      profilePicture: currentData?.profile_picture,
      profile: currentData ? mapProfileData(currentData) : null,
    }),
  });
  const dispatch = useDispatch();

  const openCookiePreferences = () => dispatch(openCookiePreferencesAction());

  if (profile)
    return (
      <Box component="section" id="profile" data-testid="Profile" sx={{ width: '100%', height: '100%' }}>
        <ProfilePicture picture={profilePicture} />
        <Box spacing={2} sx={{ my: 5, height: { xs: 'auto', sm: '800px' } }}>
          <HandleButton mode={mode} setMode={() => setMode((prevMode) => (prevMode === 'edit' ? 'view' : 'edit'))} />
          {mode === 'view' ? <ProfileShow profile={profile} /> : <ProfileEdit profile={profile} setMode={setMode} />}
        </Box>
        <CookiePreferenceButton onClick={openCookiePreferences} />
      </Box>
    );

  return null;
}

export default Profile;
